import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { AutogenLayoutCategory } from "./autogen/AutogenLayoutCategory";

const viewCategoryURL = "lme/general/Category?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "category",
    screenName: "Category",
    navigateToUrl: viewCategoryURL
};

export class Category extends AutogenLayoutCategory {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }
}